import { PostAPI } from 'Components/Helper/Helpers';

export const selectDashboardDetails = async request => {
    return PostAPI(request, 'DashBoard/FirmDashboardDetails');
};
